import { generatePath } from 'react-router-dom'
import { exchangeToJSON } from '../proto/generated/common'
import { TransactionType } from '../proto/generated/order'
import { WizardStrategyResultProto } from '../proto/generated/option-wizard'
import { Security } from '../proto/generated/security'
import ROUTES from '../assets/routes'
import { TradeOrder } from '../reducer/strategyBuilder.reducer'
import { getSecurityAsync, getSecurityKey } from './security'

export const STRATEGY_BUILDER_WIZARD_PENDING_KEY = 'pendingStrategyBuilderFromWizard' as const

export type StrategyBuilderWizardPending = {
    kind: 'wizard'
    batchId: string
    orders: TradeOrder[]
}

export type StrategyBuilderWizardLocationState = {
    [STRATEGY_BUILDER_WIZARD_PENDING_KEY]?: StrategyBuilderWizardPending
}

export function strategyBuilderPathForSecurity(security: Security): string {
    return generatePath(ROUTES.strategyBuilder, {
        exchange: exchangeToJSON(security.exchange ?? 0),
        symbol: security.code ?? '',
    })
}

export async function buildTradeOrdersFromWizardResult(
    row: WizardStrategyResultProto,
    _priceMultiplier: number,
): Promise<TradeOrder[]> {
    const legs = row.legs ?? []
    const orders: TradeOrder[] = []
    for (let i = 0; i < legs.length; i++) {
        const leg = legs[i]
        if (!leg.security?.code) continue
        const sec = await getSecurityAsync(getSecurityKey(leg.security.exchange ?? 0, leg.security.code))
        if (!sec) continue
        orders.push({
            security: sec,
            clientOrderId: `wizard-${row.id}-${i}`,
            transactionType: leg.side ?? TransactionType.BUY,
            selected: true,
            quantity: leg.quantity,
            price: leg.priceUsed,
        })
    }
    return orders
}
